// export default function Page(){
//   return (
//     <div className="page">
//       <h1>Our Projects</h1>
//       <p>Dummy content for Our Projects.</p>
//       <img src="https://via.placeholder.com/800x300" alt="dummy"/>
//     </div>
//   );
// }

import React from "react";
import "../styles/projects.css";
import heroImg from "../assets/images/Project-heroimage.jpg";

/* Dummy images (replace with your real ones) */
const beforeImages = [
  require("../assets/images/BeforAfter1.jpg"),
  require("../assets/images/BeforeAfter2.jpg"),
  require("../assets/images/BeforeAfter9.jpg"),
  require("../assets/images/BeforAfter4.jpg"),
  require("../assets/images/BeforeAfter5.jpg"),
  require("../assets/images/BeforeAfter6.jpg"),
  require("../assets/images/BeforeAfter7.jpg"),
  require("../assets/images/BeforeAfter8.jpg"),
];

const afterImages = [
  require("../assets/images/BeforAfter10.jpg"),
  require("../assets/images/BeforeAfter11.jpg"),
  require("../assets/images/BeforeAfter12.jpg"),
  require("../assets/images/BeforeAfter13.jpg"),
  require("../assets/images/BeforeAfter14.jpg"),
  require("../assets/images/BeforeAfter15.jpg"),
];

const Gallery = () => {
  return (
    <div className="gallery-page">
      {/* HERO */}
      <section className="gallery-hero">
        <div className="gallery-hero-left">
          <h1>Proven Results. Real Environments. Trusted Delivery.</h1>
          <p>
            At VGM Facilities Management, our projects showcase the quality,
            professionalism, and attention to detail that define our work. From
            security installations to full facilities upgrades, every project is
            delivered with safety, efficiency, and client satisfaction at its
            core.
          </p>
          <a href="/contact" className="gal-btn">
            Get In Touch
          </a>
        </div>

        <div className="gallery-hero-right">
          <img src={heroImg} alt="" />
        </div>
      </section>

      {/* INTRO */}
      <section className="gallery-intro">
        <h2>Browse Our Recent Projects!</h2>
        <p>
          Explore a selection of completed projects across commercial,
          industrial, and public-sector environments. Each project reflects our
          commitment to high standards, compliance, and reliable execution.
        </p>
      </section>

      {/* BEFORE */}
      <section className="gallery-section">
        <h2 className="section-title">Before</h2>
        <div className="gallery-grid">
          {beforeImages.map((img, index) => (
            <div key={index} className="gallery-card">
              <img src={img} alt="" />
            </div>
          ))}
        </div>
      </section>

      {/* AFTER */}
      <section className="gallery-section">
        <h2 className="section-title">After</h2>
        <div className="gallery-grid">
          {afterImages.map((img, index) => (
            <div key={index} className="gallery-card">
              <img src={img} alt="" />
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Gallery;
